module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auteur-single"
  }, [_c('loader'), _vm._v(" "), _c('div', {
    staticClass: "page-title-container"
  }, [(_vm.author && _vm.author.versions) ? _c('h1', [_vm._v(_vm._s(_vm.versionLanguage(_vm.author.versions).name))]) : _vm._e()]), _vm._v(" "), (_vm.author && _vm.author.versions) ? _c('div', {
    staticClass: "row author-row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1 column"
  }, [_c('div', {
    staticClass: "inner-links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'authors'
      }
    }
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n          Voir tous les auteurs\n        ")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.versionLanguage(_vm.author.versions).name))]), _vm._v(" "), _c('p', [_vm._v("Les épigrames de cet auteur :")]), _vm._v(" "), _c('div', {
    staticClass: "overflow"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.author.entities), function(listItem, index) {
    return _c('li', {
      directives: [{
        name: "track-by",
        rawName: "v-track-by",
        value: (index),
        expression: "index"
      }],
      staticClass: "index-list",
      on: {
        "mouseover": _vm.addClass
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'epigram',
          params: {
            id: listItem.id_entity
          }
        }
      }
    }, [_c('span', {
      staticClass: "dash"
    }, [_c('span', {
      staticClass: "inner-dash"
    })]), _vm._v("\n                    " + _vm._s(listItem.title) + "\n                    "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(index + 1)))])])], 1)
  }))])])])]) : _c('div', {
    staticClass: "notExist"
  }, [_c('p', [_vm._v("L'auteur que vous cherchez n'existe pas")]), _vm._v(" "), _c('back-btn')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cf34562"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AuthorSingleComponent.vue
// module id = 101
// module chunks = 0